import type { TextProps } from "@octopusdeploy/design-system-components";
import { TextWithLabel as Text } from "@octopusdeploy/design-system-octopus-components";
import { generateSlug } from "@octopusdeploy/utilities";
import { useEffect, useState } from "react";
import * as React from "react";
import IconButtonList from "~/components/IconButtonList";
import { IconButtonWithTooltip } from "~/components/IconButtonWithTooltip/index";
import InputWithActions from "~/components/InputWithActions/index";
export type PolicySlugEditorProps = TextProps & {
    policyName: string;
};
export function PolicySlugEditor({ onChange: onChangeProp, policyName, readOnly, ...rest }: PolicySlugEditorProps) {
    const [currentValue, setCurrentValue] = useState(rest.value);
    const [validSlug, setValidSlug] = useState(rest.value);
    const [editing, setEditing] = useState(false);
    const generatePolicySlug = (name: string, trimTrailingDashes: boolean = true) => {
        return generateSlug(name, trimTrailingDashes).replaceAll("-", "_");
    };
    useEffect(() => {
        if (!editing) {
            const newCurrentValue = generatePolicySlug(policyName, false);
            setCurrentValue(newCurrentValue);
            // Store the current value but as a valid slug
            const newValidSlug = generatePolicySlug(newCurrentValue);
            setValidSlug(newValidSlug);
            onChangeProp(newValidSlug);
        }
    }, [editing, onChangeProp, policyName]);
    // Ensure any input is converted to a slug valid for rego package (does not cover all cases though)
    const onChange = (input: string) => {
        const newCurrentValue = generatePolicySlug(input, false);
        setCurrentValue(newCurrentValue);
        // Store the current value but as a valid slug
        const newValidSlug = generatePolicySlug(newCurrentValue);
        setValidSlug(newValidSlug);
        onChangeProp(newValidSlug);
    };
    // Once we lose focus, update the value to the valid one
    const onBlur = () => {
        onChange(validSlug);
    };
    const onEditClick = () => setEditing(true);
    const onCancelEditClick = () => {
        setEditing(false);
        onChange(policyName);
    };
    const onUpdateClick = () => {
        const newSlug = generatePolicySlug(policyName);
        onChange(newSlug);
        setEditing(true);
    };
    const renderActions = () => {
        const buttons: Array<React.ReactElement> = [];
        if (!editing && !readOnly)
            buttons.push(<IconButtonWithTooltip accessibleName={`Change slug`} toolTipContent={"Change"} onClick={onEditClick} icon="PenLineIcon"/>);
        if (editing)
            buttons.push(<IconButtonWithTooltip accessibleName={`Cancel editing slug`} toolTipContent={"Cancel"} onClick={onCancelEditClick} icon="XmarkIcon"/>);
        if (policyName && generatePolicySlug(policyName) !== validSlug)
            buttons.push(<IconButtonWithTooltip accessibleName={"Update slug to match name"} toolTipContent={"Update"} onClick={onUpdateClick} icon={"ArrowRefreshIcon"}/>);
        return <IconButtonList buttons={buttons}/>;
    };
    return (<>
            <InputWithActions input={<Text {...rest} value={currentValue} onChange={onChange} onBlur={onBlur} disabled={!editing} helperText={"Once a policy been committed the slug can not be edited in Octopus."}/>} actions={renderActions()}/>
        </>);
}
export default PolicySlugEditor;
